/* Tema Sándalo — interacciones base */
(function () {
  "use strict";

  /* ---------- Galería: miniaturas ---------- */
  document.querySelectorAll(".thumbs .thumb").forEach(function (t) {
    t.addEventListener("click", function () {
      var src = t.getAttribute("data-thumb");
      var main = document.getElementById("MainImage");
      if (main && src) main.src = src;
      document.querySelectorAll(".thumbs .thumb").forEach(function (x) { x.classList.remove("is-active"); });
      t.classList.add("is-active");
    });
  });

  /* ---------- Cantidad ---------- */
  document.querySelectorAll("[data-qty]").forEach(function (b) {
    b.addEventListener("click", function () {
      var input = document.querySelector("[data-qty-input]");
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v += parseInt(b.getAttribute("data-qty"), 10);
      if (v < 1) v = 1;
      input.value = v;
    });
  });

  /* ---------- Selección de variante ---------- */
  var form = document.getElementById("product-form");
  if (form) {
    var select = form.querySelector(".product-variants");

    function currentSelections() {
      var sel = [];
      form.querySelectorAll(".opt").forEach(function (opt) {
        var active = opt.querySelector(".opt-btn.is-active");
        sel.push(active ? active.getAttribute("data-value") : null);
      });
      return sel;
    }

    function syncVariant() {
      if (!select) return;
      var sel = currentSelections();
      var title = sel.join(" / ");
      var match = null;
      Array.prototype.forEach.call(select.options, function (o) {
        if (o.textContent.trim() === title) match = o;
      });
      // si no hay selección múltiple (producto simple), usa la primera
      if (!match && select.options.length === 1) match = select.options[0];
      if (!match) return;
      select.value = match.value;

      // precio
      var wrap = document.querySelector("[data-price-wrap]");
      if (wrap) {
        var now = match.getAttribute("data-price");
        var was = match.getAttribute("data-compare");
        var pct = match.getAttribute("data-pct");
        var html = '<div class="price">';
        if (was) {
          html += '<span class="now">' + now + '</span><span class="was">' + was + '</span><span class="pct">-' + pct + '%</span>';
        } else {
          html += '<span class="now reg">' + now + '</span>';
        }
        html += "</div>";
        wrap.innerHTML = html;
      }

      // disponibilidad → compra vs avísame
      var available = match.getAttribute("data-available") === "true";
      var buy = form.querySelector("[data-buy-block]");
      var notify = form.querySelector("[data-notify-block]");
      if (buy) buy.hidden = !available;
      if (notify) notify.hidden = available;
    }

    form.querySelectorAll(".opt-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = btn.getAttribute("data-option-index");
        var group = btn.closest(".opt-values");
        group.querySelectorAll(".opt-btn").forEach(function (x) { x.classList.remove("is-active"); });
        btn.classList.add("is-active");
        var lbl = btn.closest(".opt").querySelector("[data-selected-option]");
        if (lbl) lbl.textContent = btn.getAttribute("data-value");
        syncVariant();
      });
    });
    syncVariant();
  }

  /* ---------- Guía de tallas: modal + calculadora ---------- */
  var sg = document.getElementById("SizeGuide");
  document.querySelectorAll("[data-open-size-guide]").forEach(function (b) {
    b.addEventListener("click", function () { if (sg && sg.showModal) sg.showModal(); });
  });
  if (sg) {
    sg.querySelectorAll("[data-close-size-guide]").forEach(function (b) {
      b.addEventListener("click", function () { sg.close(); });
    });
    sg.addEventListener("click", function (e) { if (e.target === sg) sg.close(); });
  }

  var BRA = [
    { t: "30", cont: [63, 67], copaB: [80, 84], copaC: null },
    { t: "32", cont: [68, 72], copaB: [85, 89], copaC: null },
    { t: "34", cont: [73, 77], copaB: [90, 94], copaC: [92, 96] },
    { t: "36", cont: [78, 83], copaB: [95, 99], copaC: [97, 101] },
    { t: "38", cont: [84, 89], copaB: [100, 104], copaC: [102, 106] },
    { t: "40", cont: [90, 95], copaB: [105, 109], copaC: [107, 111] },
    { t: "42", cont: [96, 101], copaB: [110, 111], copaC: null }
  ];
  var PANTY = [
    { t: "S", cad: [85, 95] },
    { t: "M", cad: [96, 105] },
    { t: "L", cad: [106, 115] },
    { t: "XL", cad: [116, 125] }
  ];
  function pickIdx(val, arr, key) {
    if (isNaN(val) || val <= 0) return -1;
    for (var i = 0; i < arr.length; i++) { if (val <= arr[i][key][1]) return i; }
    return arr.length - 1;
  }
  function sgNum(el) { return el ? parseFloat(String(el.value).replace(",", ".")) : NaN; }

  document.querySelectorAll("[data-sg-root]").forEach(function (root) {
    root.querySelectorAll(".sg-tab").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var name = tab.getAttribute("data-sg-tab");
        root.querySelectorAll(".sg-tab").forEach(function (x) { x.classList.remove("is-active"); });
        tab.classList.add("is-active");
        root.querySelectorAll("[data-sg-panel]").forEach(function (p) {
          p.hidden = p.getAttribute("data-sg-panel") !== name;
        });
      });
    });
    root.querySelectorAll("[data-sg-calc]").forEach(function (calc) {
      var kind = calc.getAttribute("data-sg-calc");
      var out = calc.querySelector("[data-sg-out]");
      var go = calc.querySelector("[data-sg-go]");
      if (!go || !out) return;
      function show(html, ok) {
        out.innerHTML = html;
        out.hidden = false;
        out.className = "sg-result" + (ok ? " ok" : " warn");
      }
      go.addEventListener("click", function () {
        if (kind === "bra") {
          var cont = sgNum(calc.querySelector('[data-f="cont"]'));
          var busto = sgNum(calc.querySelector('[data-f="busto"]'));
          if (isNaN(cont) || isNaN(busto)) { show("Ingresa tu contorno (bajo busto) y tu busto.", false); return; }
          var idx = pickIdx(cont, BRA, "cont");
          if (idx < 0) { show("Revisa tus medidas.", false); return; }
          show("Tu talla de brasier es la <b>" + BRA[idx].t + "</b>", true);
        } else {
          var cad = sgNum(calc.querySelector('[data-f="cad"]'));
          var ip = pickIdx(cad, PANTY, "cad");
          if (ip < 0) { show("Ingresa tu medida de cadera.", false); return; }
          show("Tu talla de panty es la <b>" + PANTY[ip].t + "</b>", true);
        }
      });
    });
  });

  /* ---------- Favoritos con pestañas ---------- */
  document.querySelectorAll("[data-feat-tabs]").forEach(function (root) {
    var pills = root.querySelectorAll(".ft-pill");
    pills.forEach(function (p) {
      p.addEventListener("click", function () {
        var t = p.getAttribute("data-ft-tab");
        pills.forEach(function (x) { x.classList.remove("is-active"); x.setAttribute("aria-selected", "false"); });
        p.classList.add("is-active"); p.setAttribute("aria-selected", "true");
        root.querySelectorAll("[data-ft-panel]").forEach(function (panel) {
          panel.hidden = panel.getAttribute("data-ft-panel") !== t;
        });
      });
    });
  });

  /* ---------- Carrusel de banners ---------- */
  document.querySelectorAll("[data-carousel]").forEach(function (car) {
    var track = car.querySelector("[data-hc-track]");
    if (!track) return;
    var slides = track.children;
    var n = slides.length;
    if (n < 2) return;
    var i = 0;
    var dots = car.querySelectorAll("[data-hc-dot]");
    var ms = parseInt(car.getAttribute("data-autoplay") || "0", 10);
    var timer = null;
    function go(k) {
      i = (k + n) % n;
      track.style.transform = "translateX(-" + (i * 100) + "%)";
      dots.forEach(function (d, di) { d.classList.toggle("is-active", di === i); });
    }
    function reset() { if (timer) clearInterval(timer); if (ms > 0) timer = setInterval(function () { go(i + 1); }, ms); }
    var prev = car.querySelector("[data-hc-prev]"); if (prev) prev.addEventListener("click", function () { go(i - 1); reset(); });
    var next = car.querySelector("[data-hc-next]"); if (next) next.addEventListener("click", function () { go(i + 1); reset(); });
    dots.forEach(function (d) { d.addEventListener("click", function () { go(parseInt(d.getAttribute("data-hc-dot"), 10)); reset(); }); });
    var sx = null;
    track.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener("touchend", function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); reset(); }
      sx = null;
    });
    car.addEventListener("mouseenter", function () { if (timer) { clearInterval(timer); timer = null; } });
    car.addEventListener("mouseleave", reset);
    reset();
  });

  /* ---------- FAQ: cerrar otras al abrir una (opcional) ---------- */
  /* (los <details> ya funcionan sin JS) */

  /* ---------- Menú móvil ---------- */
  var mt = document.querySelector("[data-menu-toggle]");
  if (mt) mt.addEventListener("click", function () {
    document.querySelector(".nav").classList.toggle("is-open");
  });
  /* Acordeón de categorías en móvil (tocar expande, no navega) */
  document.querySelectorAll(".nav-mega > a").forEach(function (a) {
    a.addEventListener("click", function (e) {
      if (window.matchMedia("(max-width: 900px)").matches) {
        e.preventDefault();
        var parent = a.parentElement;
        var wasOpen = parent.classList.contains("open");
        document.querySelectorAll(".nav-mega.open").forEach(function (x) { x.classList.remove("open"); });
        if (!wasOpen) parent.classList.add("open");
      }
    });
  });

  /* ---------- Formulario de pedido (empresarias) ---------- */
  var orderRows = document.querySelector("[data-order-rows]");
  if (orderRows) {
    function makeRow() {
      var r = document.createElement("div");
      r.className = "of-row";
      r.setAttribute("data-order-row", "");
      r.innerHTML =
        '<input type="text" placeholder="Ej. SB-0725" data-f="ref">' +
        '<input type="text" placeholder="Ej. Nude" data-f="color">' +
        '<input type="text" placeholder="Ej. 36" data-f="talla">' +
        '<input type="number" min="1" value="1" data-f="cant">' +
        '<button type="button" class="of-del" data-order-del aria-label="Quitar">×</button>';
      return r;
    }
    var addBtn = document.querySelector("[data-order-add]");
    if (addBtn) addBtn.addEventListener("click", function () { orderRows.appendChild(makeRow()); });
    orderRows.addEventListener("click", function (e) {
      var del = e.target.closest("[data-order-del]");
      if (del && orderRows.querySelectorAll("[data-order-row]").length > 1) {
        del.closest("[data-order-row]").remove();
      }
    });
    function compileOrder() {
      var lines = [];
      orderRows.querySelectorAll("[data-order-row]").forEach(function (row, i) {
        var g = function (f) { var el = row.querySelector('[data-f="' + f + '"]'); return el ? el.value.trim() : ""; };
        var ref = g("ref"), color = g("color"), talla = g("talla"), cant = g("cant");
        if (ref || color || cant) {
          lines.push((i + 1) + ") Ref: " + (ref || "-") + " · Color: " + (color || "-") + " · Talla: " + (talla || "-") + " · Cant: " + (cant || "1"));
        }
      });
      var text = lines.join("\n");
      var hidden = document.querySelector("[data-order-compiled]");
      if (hidden) hidden.value = text;
      return text;
    }
    function buildPayload() {
      var g = function (id) { var e = document.getElementById(id); return e ? e.value.trim() : ""; };
      var items = [];
      orderRows.querySelectorAll("[data-order-row]").forEach(function (row) {
        var gf = function (f) { var el = row.querySelector('[data-f="' + f + '"]'); return el ? el.value.trim() : ""; };
        if (gf("ref") || gf("color") || gf("cant")) items.push({ ref: gf("ref"), color: gf("color"), talla: gf("talla"), cant: gf("cant") || "1" });
      });
      var notasEl = document.querySelector('.of-form textarea[name="contact[Notas]"]');
      return {
        empresaria: { cedula: g("of-ced"), nombre: g("of-name"), correo: g("of-mail"), celular: g("of-wa"), ciudad: g("of-city"), direccion: g("of-addr") },
        items: items,
        notas: notasEl ? notasEl.value.trim() : ""
      };
    }
    function showOrderSuccess() {
      var actions = document.querySelector(".of-actions"); if (actions) actions.hidden = true;
      var form = document.getElementById("order-form");
      var msg = document.createElement("p"); msg.className = "of-ok";
      msg.textContent = "✓ ¡Solicitud enviada! Recibimos tu pedido y te contactamos para confirmar. 💗";
      if (form) form.insertBefore(msg, form.firstChild);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    var oform = document.getElementById("order-form");
    if (oform) oform.addEventListener("submit", function (e) {
      compileOrder();
      if (window.SANDALO_SUBMIT_URL) {
        e.preventDefault();
        fetch(window.SANDALO_SUBMIT_URL, { method: "POST", mode: "no-cors", headers: { "Content-Type": "text/plain;charset=utf-8" }, body: JSON.stringify(buildPayload()) })
          .then(function () { showOrderSuccess(); })
          .catch(function () { showOrderSuccess(); });
      }
      /* Si no hay SANDALO_SUBMIT_URL, se envía por el formulario de contacto de Shopify (correo). */
    });
    var wa = document.querySelector("[data-order-wa]");
    if (wa) wa.addEventListener("click", function (e) {
      e.preventDefault();
      var pedido = compileOrder();
      var emp = (document.getElementById("of-name") || {}).value || "";
      var city = (document.getElementById("of-city") || {}).value || "";
      var msg = "Hola Sándalo, soy " + emp + (city ? (" de " + city) : "") + ". Quiero este pedido:\n" + pedido;
      window.open("https://wa.me/" + wa.getAttribute("data-wa-number") + "?text=" + encodeURIComponent(msg), "_blank");
    });

    /* Descargar en Excel (archivo CSV que abre en Excel) */
    var dl = document.querySelector("[data-order-download]");
    if (dl) dl.addEventListener("click", function () {
      var g = function (id) { var e = document.getElementById(id); return e ? e.value.trim() : ""; };
      var sep = ";";
      var q = function (v) { v = (v == null ? "" : "" + v); return '"' + v.replace(/"/g, '""') + '"'; };
      var L = [];
      L.push("SOLICITUD DE PEDIDO - SANDALO");
      L.push("");
      L.push([q("Cédula"), q(g("of-ced"))].join(sep));
      L.push([q("Empresaria"), q(g("of-name"))].join(sep));
      L.push([q("Correo"), q(g("of-mail"))].join(sep));
      L.push([q("Celular"), q(g("of-wa"))].join(sep));
      L.push([q("Ciudad"), q(g("of-city"))].join(sep));
      L.push([q("Dirección"), q(g("of-addr"))].join(sep));
      L.push("");
      L.push([q("Referencia"), q("Color"), q("Talla"), q("Cantidad")].join(sep));
      orderRows.querySelectorAll("[data-order-row]").forEach(function (row) {
        var gf = function (f) { var el = row.querySelector('[data-f="' + f + '"]'); return el ? el.value.trim() : ""; };
        if (gf("ref") || gf("color") || gf("cant")) {
          L.push([q(gf("ref")), q(gf("color")), q(gf("talla")), q(gf("cant") || "1")].join(sep));
        }
      });
      var csv = "﻿" + L.join("\r\n");
      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      var a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = "pedido-" + (g("of-ced") || "empresaria") + ".csv";
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
    });

    /* Autocompletar por cédula — PUNTO DE INTEGRACIÓN.
       Define window.SANDALO_LOOKUP_URL (endpoint que recibe ?cedula= y devuelve
       {found:true, nombre, correo, celular, ciudad, direccion}). Ver README.
       Sin ese endpoint, el autocompletado queda inactivo y la empresaria llena a mano. */
    var ced = document.querySelector("[data-cedula]");
    if (ced && window.SANDALO_LOOKUP_URL) {
      ced.addEventListener("change", function () {
        var status = document.querySelector("[data-cedula-status]");
        var val = ced.value.trim();
        if (!val) return;
        if (status) status.textContent = "Buscando tus datos...";
        fetch(window.SANDALO_LOOKUP_URL + "?cedula=" + encodeURIComponent(val))
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.found) {
              var set = function (id, v) { var e = document.getElementById(id); if (e && v) e.value = v; };
              set("of-name", d.nombre); set("of-mail", d.correo); set("of-wa", d.celular);
              set("of-city", d.ciudad); set("of-addr", d.direccion);
              if (status) status.textContent = "✓ Datos cargados.";
            } else if (status) { status.textContent = "No encontramos esa cédula. Completa tus datos."; }
          })
          .catch(function () { if (status) status.textContent = "No se pudo consultar. Completa tus datos."; });
      });
    }
  }
})();
